import {
  Flex,
  LinkAnchor,
  mdBumps,
  Section,
  SectionContent,
  SectionProps,
  SectionTitle,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { generatePath, Link } from 'react-router'

import { toPolicyData } from '../../../../../../hooks/adjustments/policy/disclosure/data'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { useAdjustments } from '../../../../../../state'
import { QuoteManagementConfig } from '../../../../../../state/configuration'
import { FormFormatter } from '../../../../../formBuilder'
import { PolicyAdjustmentPath } from '../../../adjustments'
import { usePolicy } from '../../../PolicyProvider'

export interface AdjustmentSectionProps extends SectionProps {
  config: QuoteManagementConfig
  tKey: TKeyBuilder
}

export const PolicyAdjustmentSection: FunctionComponent<AdjustmentSectionProps> = ({
  config: {
    id,
    form: [firstInput],
  },
  tKey,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { policy } = usePolicy()
  const { getAdjustment } = useAdjustments()

  const toData = toPolicyData(policy.currentPolicyVersion)

  const adjustment = getAdjustment(firstInput.name)

  const sectionTKey = (key: string) => tKey('sections', id, key)

  const header = t(sectionTKey('summary'), {
    defaultValue: null,
  }) ?? <FormFormatter input={firstInput} value={toData(adjustment)} t={t} />

  return (
    <Section data-testid={id} width={1} {...props}>
      <SectionTitle>{t(sectionTKey('header'))}</SectionTitle>
      <SectionContent>
        <Flex
          variant='raised'
          width={1}
          flexDirection='column'
          justifyContent='flex-start'
        >
          <Flex p={mdBumps} width={1}>
            <Typo fontWeight='bold' mr={2}>
              {header}
            </Typo>
            <LinkAnchor
              to={generatePath(PolicyAdjustmentPath.Section, { sectionId: id })}
              as={Link}
              variant='standalone'
              typoSize='sm'
              data-testid='update-link'
            >
              {t(tKey('actions.update'))}
            </LinkAnchor>
          </Flex>
        </Flex>
      </SectionContent>
    </Section>
  )
}
